module.exports = __webpack_public_path__ + "static/media/CTLI_17-444w.7d7df824.png";